var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7012 2.2928C10.3429 0.934466 8.4179 0.151133 6.30123 0.3678C3.2429 0.676133 0.72623 3.15947 0.384564 6.2178C-0.0737697 10.2595 3.05123 13.6678 6.9929 13.6678C9.65123 13.6678 11.9346 12.1095 13.0012 9.8678C13.2679 9.30947 12.8679 8.6678 12.2512 8.6678C11.9429 8.6678 11.6512 8.83447 11.5179 9.10947C10.5762 11.1345 8.3179 12.4178 5.85123 11.8678C4.00123 11.4595 2.50956 9.95113 2.1179 8.10113C1.4179 4.8678 3.87623 2.00113 6.9929 2.00113C8.37623 2.00113 9.60956 2.57613 10.5096 3.48447L9.25123 4.7428C8.72623 5.2678 9.0929 6.1678 9.83456 6.1678H12.8262C13.2846 6.1678 13.6596 5.7928 13.6596 5.33447V2.3428C13.6596 1.60113 12.7596 1.22613 12.2346 1.75113L11.7012 2.2928Z",
    fill: "#E84C3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestartIcon);
export default __webpack_public_path__ + "static/media/restart-icon.19002ec8263dfb21b14a3ef0b7a05896.svg";
export { ForwardRef as ReactComponent };